module.exports ={
    gateway: {
        operate:'操作',
        add:'新 增',
        edit:'修 改',
        del:'删 除',
        restart:'重新启动',
        sure: '确 定',
        cancel: '取 消',
        attr:{
            name:'名称',
            macAddress:'Mac地址',
            status:'状态',
            online:'在线',
            online1:'在线',
            offline:'离线',
            offline1:'离线',
            lastUpdateTime:'更新时间',
            wifiVersion:'WiFi固件版本',
            bleVersion:'蓝牙固件版本',
            subModel: '型号'
        },
        addTip: {
            success: '网关添加成功',
            exist: '网关已存在',
            fail: '网关添加失败',
            permission: '您没有权限添加网关'
        },
        editTip:{
            success: '网关修改成功',
            exist: '修改的网关不存在',
            fail: '网关修改失败',
            permission: '您没有权限修改网关'
        },
        delTip:{
            success: '网关删除成功',
            exist: '删除的网关不存在',
            fail: '网关删除失败',
            msg:'确定删除{name}吗?',
            permission: '您没有权限删除网关'
        },
        restartTip:{
            success: '网关正在重启,请稍后刷新页面获取最新状态',
            fail: '网关重启失败',
            msg:'确定重启{name}吗?'
        },
        validMsg: {
            name:'请输入网关名',
            nameLen:'长度不能超过20个字符',
            mac:'请输入网关Mac地址',
            macRule:'请输入正确的Mac地址',
            macExist: '网关已存在',
            macFail: '获取失败,请重新输入'
        },
        wifiUpgrade: 'wifi固件升级',
        bleUpgrade: '蓝牙固件升级',
        version: '固件版本',
        select: '请选择',
        upgradeValidMsg: {
            id: '请选择一个版本'
        },
        chooseVersion: '升级',
        upgradeTip: {
            getVersionfail: '升级版本获取失败',
            success: '网关{mac}: 固件正在升级中，请稍后操作',
            fail: '网关{mac}: 网关型号与固件型号不匹配，升级失败',
            currentVersion: '网关{mac}: 固件已为所需升级版本',
            addFirst: '请先选择网关',
            err: '升级失败',
            exist: '网关{mac}: 无法获取该网关的型号，升级失败',
            timeLimit: '请勿频繁进行升级操作',
            unexist: '网关{mac}: 网关不存在',
            offline: '网关{mac}: 网关离线，无法升级',
            permission: '您没有权限升级'
        },
        submiting: '提交中...'
    }
}


// WEBPACK FOOTER //
// ./src/components/common/lang/zh/gateway.js